import { numberWithCommas } from '@common/utils';

import { Message } from '../types';

export function getPointRewardMessage() {
  const getPointTitle = (reward: number): Message => {
    return {
      sections: [
        {
          type: 'normal',
          text: `포인트 최대`,
        },
        {
          type: 'normal',
          text: ` ${numberWithCommas(reward)}P`,
          style: { fontWeight: 500 },
        },
        {
          type: 'normal',
          text: ' 적립',
        },
      ],
    };
  };

  const getDecisionMessage = (shopName: string, reward: number): Message => {
    return {
      sections: [
        {
          type: 'ellipsis',
          text: shopName,
        },
        {
          type: 'fixed',
          text: ` 추가 적립 ${numberWithCommas(reward)}P`,
        },
      ],
    };
  };

  const getFirstOrderMessage = (reward: number): Message => {
    return {
      sections: [
        {
          type: 'normal',
          text: `첫 구매 시 추가 적립 ${numberWithCommas(reward)}P`,
        },
      ],
    };
  };

  const getReviewWriteMessage = (reward: number): Message => {
    return {
      sections: [
        {
          type: 'normal',
          text: `리뷰 작성 시 최대 ${numberWithCommas(reward)}P`,
        },
      ],
    };
  };

  const getFirstReviewMessage = (reward: number): Message => {
    return {
      sections: [
        {
          type: 'normal',
          text: `선착순 리뷰 최대 ${numberWithCommas(reward)}P 적립`,
        },
      ],
    };
  };

  const getBestReviewMessage = (reward: number): Message => {
    return {
      sections: [
        {
          type: 'normal',
          text: `베스트 리뷰 선정 시 추가 적립 ${numberWithCommas(reward)}P`,
        },
      ],
    };
  };

  return {
    getPointTitle,
    getDecisionMessage,
    getFirstOrderMessage,
    getReviewWriteMessage,
    getFirstReviewMessage,
    getBestReviewMessage,
  };
}
